export default __webpack_public_path__ + "static/media/tablefilter.c601034b.svg";